module.exports = __webpack_public_path__ + "static/media/processLargePic.03db42f4.svg";